import { Day, useCreateHoursOff } from "@mc-intranet/shared";
import { Add } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Stack,
  Typography
} from "@mui/material";
import { useAtomValue } from "jotai";
import { Moment } from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { daysByUserQueryVariablesSelector } from "../../../atoms";
import { useGraphQLClient } from "../../../cache";
import Times from "./Times";

interface Props {
  day: Day;
  setCurrentDay: React.Dispatch<
    React.SetStateAction<Day | undefined | null>
  >;
}

const CreateHoursOff: React.FC<Props> = (props) => {
  const { day, setCurrentDay } = props;
  const { client } = useGraphQLClient();
  const variables = useAtomValue(daysByUserQueryVariablesSelector);

  const [addingNew, setAddingNew] = useState(false);
  const [hoursOff, setHoursOff] = useState({ from: null, to: null });

  const {
    createHoursOffMutation,
    options: { isLoading: loading }
  } = useCreateHoursOff({
    day,
    setCurrentDay,
    client,
    variables
  });

  //(logMessage, userId, day, setCurrentDay);

  useEffect(() => {
    if (!loading) {
      setAddingNew(false);
      setHoursOff({ from: null, to: null });
    }
  }, [loading]);

  const onTimeChange = (time: Moment | null, name: string) => {
    setHoursOff((value) => {
      return {
        ...value,
        [name]: time?.format("HH:mm:ss.SSS")
      };
    });
  };

  const onConfirm = () => {
    // console.log("hoursOff", hoursOff);
    createHoursOffMutation(
      {
        dayId: day.documentId as string,
        from: hoursOff.from,
        to: hoursOff.to
      },
      {
        onSuccess: () => {
          toast.success("Permessi richiesti con successo", {
            position: toast.POSITION.TOP_CENTER
          });
        },
        onError: (error: any) => {
          console.log("error ", error);
          toast.error(error?.response?.error.message, {
            position: toast.POSITION.TOP_CENTER
          });
        }
      }
    );
  };

  return (
    <>
      {addingNew && (
        <Card sx={{ bgcolor: "background.default", mb: 2, minWidth: 275 }}>
          <CardContent>
            <Typography variant="h5" component="h5">
              Nuovo permesso
            </Typography>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
              mt={2}
              width="100%"
            >
              <Times day={day} isCreate onTimeChange={onTimeChange} />
            </Stack>
          </CardContent>
          <CardActions>
            <Button
              key="1"
              color="secondary"
              onClick={() => setAddingNew(false)}
            >
              Annulla
            </Button>
            <LoadingButton
              key="2"
              variant="contained"
              loading={loading}
              disabled={!hoursOff.from || !hoursOff.to}
              onClick={onConfirm}
            >
              Conferma
            </LoadingButton>
          </CardActions>
        </Card>
      )}
      {!addingNew && (
        <Button
          className="add-btn"
          variant="outlined"
          fullWidth
          startIcon={<Add />}
          onClick={() => setAddingNew(true)}
          sx={{ mb: 2 }}
        >
          Permessi
        </Button>
      )}
    </>
  );
};

export default CreateHoursOff;
